import React from 'react';

interface CheckMonitorIconProps {
  size?: number;
  color?: string;
}

/**
 * CheckMonitorIcon Component
 * @description A monitor/screen icon with checkmark for successful monitoring
 */
export const CheckMonitorIcon: React.FC<CheckMonitorIconProps> = ({ 
  size = 32, 
  color = '#009951' 
}) => {
  return (
    <svg 
      xmlns="http://www.w3.org/2000/svg" 
      width={size} 
      height={size} 
      fill="none" 
      viewBox="0 0 32 32"
    >
      <path 
        stroke={color} 
        strokeLinecap="round" 
        strokeLinejoin="round" 
        strokeWidth="2" 
        d="M9.333 29.334h13.333"
      />
      <path 
        fill={color} 
        d="M26.4 3c.69 0 1.352.272 1.84.758.487.485.76 1.144.761 1.83v16.824c0 .686-.274 1.345-.762 1.83A2.6 2.6 0 0 1 26.4 25H5.6c-.689 0-1.35-.272-1.838-.758A2.58 2.58 0 0 1 3 22.412V5.588c0-.686.274-1.345.762-1.83A2.6 2.6 0 0 1 5.6 3zm-6.026 7.01a1 1 0 0 0-1.414 0l-4.627 4.626-1.959-1.96a1 1 0 1 0-1.414 1.415l2.667 2.666a1 1 0 0 0 1.414 0l5.333-5.333a1 1 0 0 0 0-1.414"
      />
    </svg>
  );
};

export default CheckMonitorIcon;

